import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import config from '../../config';
import { useGlobalContext } from '../../GlobalContext';
import { GetById, GetAll } from '../../service/PageService'; // You need to create this if not existing

export default function ViewPage() {
  const {
    setIsLoading,
    setAppError,
    setAppErrorMessage,
    setAppErrorTitle,
    setAppErrorMode,
  } = useGlobalContext();

  const { id } = useParams(); // Get page id from route params
  const [page, setPage] = useState(null);
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [keyword, setKeyword] = useState('');

  const fetchPageById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      if (response.status === 200) {
        setPage(response.page);
        setName(response.page.name);
        setDescription(response.page.description);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPageById();
    }
  }, [id]);


  //all pages
  const [pages, setPages] = useState([]);
  const fetchPages = async () => {
    try {
      setIsLoading(true);
      const response = await GetAll(1, 9999, keyword); // Load latest 4 pages
      setPages(response.pages || []);
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load latest pages");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchPages();
  }, []);


  return (
    <>
      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            {page ? (
              <>
                <h1>{page.name}</h1>
              </>
            ) : null}

            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/page/list"> Pages </Link>  {page && <> / {page.name}</>}
            </span>
          </div>

          <div className='page-content'>
                <div className="portal">
                  <div className='portal-body latest-page'>
                    <div className='table-content'>
                      <div className="row">
                        {page ? (
                          <>
                            {/* Left Side: Single Page */}
                            <div className="col-lg-8">
                              <div className="card shadow-sm border-0 rounded-4 overflow-hidden position-relative">
                                <div className="card-body">                                  
                                  <p className="card-text text-muted">{page.description}</p>
                                </div>
                              </div>
                            </div>

                            {/* Right Side: Latest Pages */}
                            <div className="col-lg-4 d-none d-lg-block">
                              <div className="card shadow-sm border-0 rounded-4 p-3">
                                <h6 className="fw-bold mb-3">
                                  <i className="bi bi-clock-history me-1"></i> Other Pages
                                </h6>
                                <ul className="list-group list-group-flush">
                                  {pages && pages.length > 0 ? (
                                    pages.slice(0, 5).map((item) => {
                                      return (
                                        <li key={item.id} className="list-group-item px-0 py-2">
                                          <Link to={`/page/view/${item.id}`} className="text-decoration-none text-dark fw-semibold">
                                            <i className="bi bi-journal-text me-2"></i>{item.name}
                                          </Link>
                                        </li>
                                      );
                                    })
                                  ) : (
                                    <li className="list-group-item px-0">No latest pages.</li>
                                  )}
                                </ul>
                              </div>
                            </div>
                          </>
                        ) : (
                          <div className="col-12 text-center">
                            <p>No Page found...!</p>
                          </div>
                        )}
                      </div>


                    </div>
                  </div>

                  <br />
              
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
